export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const REACT_APP_APIURL = process.env.REACT_APP_APIURL;
export const REACT_APP_SENTRY_KEY = process.env.REACT_APP_SENTRY_KEY;
export const REACT_APP_STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const REACT_APP_AMPLITUDE_ANALYTICS_KEY = process.env.REACT_APP_AMPLITUDE_ANALYTICS_KEY;
export const REACT_APP_GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
export const REACT_APP_FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
